<template>
  <div>
    <div class="main">
      <el-form
        class="systemFont1"
        :model="specialDouponForm"
        ref="specialDouponFormRef"
        label-width="100px"
        style="width:100%;"
        hide-required-asterisk
      >
        <el-row style="width:70%;margin:auto">
          <el-col :span="17">
            <!-- 个人用户入力 -->
            <el-form-item
              :label="$t('p0413.individualUser')"
              prop="individualUser"
              style=" margin-bottom:22px"
            >
              <el-input
                v-model="specialDouponForm.queryUser"
                size="courseSelect"
                maxlength="125"
                :placeholder="$t('p0413.queryCriteria')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-button type="submit" @click="getSpecialList()">{{
              $t("common.query")
            }}</el-button>
            <el-button type="submit" class="buttonWidth" @click="reset">{{
              $t("common.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 用户列表 -->
    <div v-if="showFlag">
      <el-table
        :data="userTable"
        tooltip-effect="dark"
        style="width:95%;margin:auto"
      >
        <!-- 姓名 -->
        <el-table-column
          prop="name"
          :label="$t('p0212.userName')"
          align="center"
        ></el-table-column>
        <!-- 英文姓名 -->
        <el-table-column
          prop="nameEn"
          :label="$t('p0212.englishName')"
          align="center"
        ></el-table-column>
        <!-- 昵称 -->
        <el-table-column
          prop="nickname"
          :label="$t('p0212.nickname')"
          align="center"
        ></el-table-column>
        <!-- 优惠码 -->
        <el-table-column
          prop="couponCode"
          :label="$t('p0212.couponCode')"
          align="center"
        ></el-table-column>
        <!-- 优惠码级别 -->
        <el-table-column
          prop="couponCodeLevel"
          :label="$t('p0212.couponCodeLevel')"
          align="center"
          min-width="100"
        ></el-table-column>
        <!-- 关联公司 -->
        <el-table-column
          prop="affiliation"
          :label="$t('p0212.existingCompany')"
          align="left"
          min-width="150"
        ></el-table-column>
        <!-- 注册日期 -->
        <el-table-column
          prop="createTime"
          :label="$t('samplePage.registerDate')"
          align="center"
        ></el-table-column>
        <!-- 上次更新 -->
        <el-table-column
          prop="updateTime"
          :label="$t('p0401.lastUpdated')"
          align="center"
        ></el-table-column>
        <!-- 操作 -->
        <el-table-column :label="$t('common.operation')" align="center">
          <template slot-scope="scope">
            <el-button
              size="text"
              @click="getSpecialCouponCode(scope.row.userId)"
              >{{ $t("p0413.offerSettings") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 用户详细 -->
    <el-dialog
      class="userListClass"
      width="950px"
      :visible.sync="dialogUserListShow"
      :before-close="handleUserListClose"
      :destroy-on-close="true"
    >
      <el-row style="margin:auto">
        <!-- <el-col > -->
        <el-col :span="24">
          <el-form
            class="systemFont1"
            :model="specialDouponForm"
            ref="specialDouponFormRef"
            style="width:100%;"
            hide-required-asterisk
          >
            <el-form-item>
              <!-- 姓名 -->
              <el-col :span="5"
                ><span
                  >{{ $t("p0413.name") }}{{ specialDouponForm.name }}</span
                ></el-col
              >
              <!-- 邮箱 -->
              <el-col :span="7" style="margin-left:15px"
                ><span
                  >{{ $t("p0413.email") }}{{ specialDouponForm.email }}</span
                ></el-col
              >
              <!-- 手机号 -->
              <el-col :span="5" style="margin-left:15px"
                ><span
                  >{{ $t("p0413.phone") }}{{ specialDouponForm.phoneNo }}</span
                ></el-col
              >
              <!-- 优惠码 -->
              <el-col :span="5" style="margin-left:15px"
                ><span
                  >{{ $t("p0413.codeCoupon")
                  }}{{ specialDouponForm.couponCode }}</span
                ></el-col
              >
            </el-form-item>
          </el-form>
        </el-col>
        <!-- </el-col> -->
      </el-row>
      <!-- 用户列表 -->
      <div>
        <el-table
          :data="userList"
          tooltip-effect="dark"
          style="width:95%;margin:auto"
        >
          <!-- 课程编号 -->
          <el-table-column
            prop="courseNumber6s"
            :label="$t('p0413.courseNumber')"
            align="center"
            min-width="20"
          ></el-table-column>
          <!-- 课程名称 -->
          <el-table-column
            prop="courseName"
            :label="$t('p0413.courseName')"
            header-align="left"
            align="left"
            min-width="40"
          ></el-table-column>
          <!-- 学员优惠 -->
          <el-table-column
            prop="studentDiscount"
            :label="$t('p0413.studentDiscount')"
            header-align="right"
            align="right"
            min-width="15"
          ></el-table-column>
          <!-- 介绍人佣金 -->
          <el-table-column
            prop="introducerCommission"
            :label="$t('p0413.introducerCommission')"
            header-align="right"
            align="right"
            min-width="15"
          ></el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="10"
          >
            <template slot-scope="scope">
              <el-button size="text" @click="editDiscount(scope.row)">{{
                $t("common.edit")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 设置优惠码 -->
    <el-dialog
      :title="$t('common.edit')"
      width="600px"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="padding-bottom: 20px;" v-loading="loading">
        <el-divider></el-divider>
        <el-form :model="specialUserForm" ref="specialUserFormRef">
          <!-- 课程编号 -->
          <el-form-item
            :label-width="labelWidth"
            :label="$t('p0413.courseNumber')"
            prop="courseNumber6s"
          >
            <div style="text-align: left;margin-left: 30px;">
              {{ specialUserForm.courseNumber6s }}
            </div>
          </el-form-item>
          <!-- 课程名称 -->
          <el-form-item
            :label-width="labelWidth"
            :label="$t('p0413.courseName')"
            prop="courseName"
          >
            <div style="text-align: left;margin-left: 30px;">
              {{ specialUserForm.courseName }}
            </div>
          </el-form-item>
          <!-- 学员优惠 -->
          <el-form-item
            :label="$t('p0412.studentDiscount')"
            :label-width="labelWidth"
          >
            <el-col :span="10">
              <el-form-item label-width="0px">
                <el-radio-group
                  v-model="specialUserForm.couponType"
                  style="text-align: left;width:390px"
                >
                  <el-radio label="0" @change="changeStuNo"
                    >{{ $t("p0412.deductionAmount") }}
                  </el-radio>
                  <el-radio
                    label="1"
                    @change="changeStuRate"
                    style="margin-top:23px"
                    >{{ $t("p0412.deductionRatio") }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                label-width="0px"
                prop="studentNumber"
                :rules="studentNumber"
                style="margin-bottom:20px;text-align: right"
              >
                <el-input
                  v-model="specialUserForm.studentNumber"
                  @blur="formatStuNumber"
                  size="small"
                  style="text-align: right !important"
                  :disabled="specialUserForm.couponType == 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item
                label-width="0px"
                prop="studentRate"
                :rules="studentRate"
                style="text-align: right"
              >
                <el-input
                  v-model="specialUserForm.studentRate"
                  size="small"
                  style="text-align: right !important"
                  :disabled="specialUserForm.couponType == 1 ? false : true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-form-item label-width="0px" style="margin-bottom:20px"
                ><span style="color: #606266;font-weight: 500;"
                  >({{ specialUserForm.couponCurrency }})</span
                ></el-form-item
              >
              <el-form-item label-width="0px"
                ><span style="color: #606266;font-weight: 500;"
                  >%</span
                ></el-form-item
              >
            </el-col>
          </el-form-item>
          <!-- 介绍人佣金 -->
          <el-form-item
            :label-width="labelWidth"
            :label="$t('p0412.introducerCommission')"
            style="margin-top:20px"
          >
            <el-col :span="10">
              <el-form-item label-width="0px">
                <el-radio-group
                  v-model="specialUserForm.commissionType"
                  style="text-align: left;width:390px"
                >
                  <el-radio label="0" @change="changeIntNo"
                    >{{ $t("p0412.fixedAmount") }}
                  </el-radio>
                  <el-radio
                    label="1"
                    @change="changeIntRate"
                    style="margin-top:23px"
                    >{{ $t("p0412.ratio") }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                label-width="0px"
                prop="introducerNumber"
                :rules="introducerNumber"
                style="margin-bottom:20px"
              >
                <el-input
                  v-model="specialUserForm.introducerNumber"
                  @blur="formatIntNumber"
                  size="small"
                  style="text-align: right"
                  :disabled="specialUserForm.commissionType == 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item
                label-width="0px"
                prop="introducerRate"
                :rules="introducerRate"
                style="margin-bottom:12px"
              >
                <el-input
                  v-model="specialUserForm.introducerRate"
                  size="small"
                  style="text-align: right"
                  :disabled="specialUserForm.commissionType == 1 ? false : true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-form-item label-width="0px" style="margin-bottom:20px"
                ><span style="color: #606266;font-weight: 500;"
                  >({{ specialUserForm.commissionCurrency }})</span
                ></el-form-item
              >
              <el-form-item label-width="0px"
                ><span style="color: #606266;font-weight: 500;"
                  >%</span
                ></el-form-item
              >
            </el-col>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button type="submitDialog" @click.native.prevent="handleSubmit">{{
            $t("common.submit")
          }}</el-button>
          <el-button type="return" @click.native.prevent="handleClose">{{
            $t("common.back")
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      loading: false,
      userId: undefined,
      dialogUserListShow: false,
      // 标签宽度
      labelWidth: "120px",
      // 弹框
      dialogFormVisible: false,
      // 折扣表单
      specialUserForm: {
        // 学员优惠选择
        couponType: "",
        // 学员优惠金额
        studentNumber: "",
        // 学员优惠百分比
        studentRate: "",
        // 介绍人选择
        commissionType: "",
        // 介绍人优惠金额
        introducerNumber: "",
        // 介绍人优惠百分比
        introducerRate: "",
        // 报价货币
        couponCurrency: "",
        commissionCurrency: "",
        // 优惠类别
        couponCategory: "",
        createUser: localStorage.getItem("userId"),
        // 领域
        field: "",
        // 类别
        category: "",
        // 课程编号
        courseNumber: "",
        courseNumber6s: "",
        // 课程名称
        courseName: "",
        couponCode: ""
      },
      // 旧表单
      oldSpecialUserForm: {},
      // 学员优惠金额
      studentNumberOld: "",
      // 学员优惠百分比
      studentRateOld: "",
      // 介绍人优惠金额
      introducerNumberOld: "",
      // 介绍人优惠百分比
      introducerRateOld: "",
      // 表格显示状态
      showFlag: false,
      userTable: [],
      userList: [
        {
          courseNumber6s: "",
          courseName: "",
          studentDiscount: "",
          introducerCommission: "",
          couponType: "",
          couponQuota: "",
          couponCurrency: "",
          commissionType: "",
          commissionQuota: "",
          commissionCurrency: ""
        }
      ],

      // 优惠form
      specialDouponForm: {
        queryUser: "",
        name: "",
        email: "",
        phoneNo: "",
        couponCode: ""
      },
      // 活跃的标签
      activeName: "first",
      studentNumber: [
        {
          pattern: /^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/,
          message: this.$t("p0412.twoDecimals"),
          trigger: "blur"
        }
      ],
      studentRate: [
        {
          pattern: /^([1-9]\d|\d)$/,
          message: this.$t("p0412.integer"),
          trigger: "blur"
        }
      ],
      introducerNumber: [
        {
          pattern: /^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/,
          message: this.$t("p0412.twoDecimals"),
          trigger: "blur"
        }
      ],
      introducerRate: [
        {
          pattern: /^([1-9]\d|\d)$/,
          message: this.$t("p0412.integer"),
          trigger: "blur"
        }
      ]
    };
  },
  methods: {
    // 选择的标签
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 获取查询用户
    getSpecialList() {
      if (
        this.specialDouponForm.queryUser == null ||
        this.specialDouponForm.queryUser == ""
      ) {
        this.$message.error(this.$t("p0413.enterQuery"));
        this.showFlag = false;
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/couponCode/getSpecialList";
      this.$http
        .post(
          url,
          qs.stringify({ queryUser: this.specialDouponForm.queryUser })
        )
        .then(response => {
          if (response.data.code === 200) {
            this.showFlag = true;
            this.userTable = response.data.data;
          } else {
            this.showFlag = false;
            this.$message.error(response.data.message);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 优惠设置
    async getSpecialCouponCode(userId) {
      let loading = false;
      if (userId) {
        this.userId = userId;
        loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
      }
      this.loading = true;
      let url = "/api/couponCode/getSpecialCouponCode";
      await this.$http
        .post(url, qs.stringify({ userId: this.userId }))
        .then(response => {
          if (response.data.code === 200) {
            this.showFlag = true;
            this.specialDouponForm.name = response.data.data.name;
            if (
              response.data.data.email != null &&
              response.data.data.email != ""
            ) {
              this.specialDouponForm.email = response.data.data.email;
            } else {
              this.specialDouponForm.email = "-";
            }
            if (
              response.data.data.phoneNo != null &&
              response.data.data.phoneNo != ""
            ) {
              this.specialDouponForm.phoneNo = response.data.data.phoneNo;
            } else {
              this.specialDouponForm.phoneNo = "-";
            }
            this.specialDouponForm.couponCode = response.data.data.couponCode;
            // console.log("response:" + JSON.stringify(response.data.data.limitCourseList));
            if (
              response.data.data.limitCourseList != null &&
              response.data.data.limitCourseList.length > 0
            ) {
              this.userList = response.data.data.limitCourseList;
              for (let i = 0; i < this.userList.length; i++) {
                // 6位课程编号
                this.userList[i].courseNumber6s =
                  this.userList[i].field +
                  this.userList[i].category +
                  this.userList[i].courseNumber;
                // 学员优惠
                if (
                  this.userList[i].couponQuota == null ||
                  this.userList[i].couponQuota == ""
                ) {
                  if (this.userList[i].couponQuota == 0) {
                    if (this.userList[i].couponType == 0) {
                      this.userList[i].studentDiscount = "0.00 CNY";
                    } else {
                      this.userList[i].studentDiscount = "0%";
                    }
                  } else {
                    this.userList[i].studentDiscount = "-";
                  }
                } else {
                  if (this.userList[i].couponType == 0) {
                    if (this.userList[i].couponQuota == 0) {
                      this.userList[i].couponQuota = "0.00";
                    } else {
                      if (
                        this.userList[i].couponQuota.toString().includes(".")
                      ) {
                        this.userList[i].couponQuota =
                          this.userList[i].couponQuota.toString().split(".")[1]
                            .length < 2
                            ? this.userList[i].couponQuota
                                .toString()
                                .split(".")[1].length < 1
                              ? this.userList[i].couponQuota.toString() + "00"
                              : this.userList[i].couponQuota.toString() + "0"
                            : this.userList[i].couponQuota;
                      } else {
                        this.userList[i].couponQuota =
                          this.userList[i].couponQuota.toString() + ".00";
                      }
                    }
                    this.userList[i].studentDiscount =
                      this.userList[i].couponQuota + " CNY";
                  } else {
                    this.userList[i].studentDiscount =
                      this.userList[i].couponQuota + "%";
                  }
                }
                // 介绍人佣金
                if (
                  this.userList[i].commissionQuota == null ||
                  this.userList[i].commissionQuota == ""
                ) {
                  if (this.userList[i].commissionQuota == 0) {
                    if (this.userList[i].couponType == 0) {
                      this.userList[i].introducerCommission = "0.00 CNY";
                    } else {
                      this.userList[i].introducerCommission = "0%";
                    }
                  } else {
                    this.userList[i].introducerCommission = "-";
                  }
                } else {
                  if (this.userList[i].commissionType == 0) {
                    if (this.userList[i].commissionQuota == 0) {
                      this.userList[i].commissionQuota = "0.00";
                    } else {
                      if (
                        this.userList[i].commissionQuota
                          .toString()
                          .includes(".")
                      ) {
                        this.userList[i].commissionQuota =
                          this.userList[i].commissionQuota
                            .toString()
                            .split(".")[1].length < 2
                            ? this.userList[i].commissionQuota
                                .toString()
                                .split(".")[1].length < 1
                              ? this.userList[i].commissionQuota.toString() +
                                "00"
                              : this.userList[i].commissionQuota.toString() +
                                "0"
                            : this.userList[i].commissionQuota;
                      } else {
                        this.userList[i].commissionQuota =
                          this.userList[i].commissionQuota.toString() + ".00";
                      }
                    }
                    this.userList[i].introducerCommission =
                      this.userList[i].commissionQuota + " CNY";
                  } else {
                    this.userList[i].introducerCommission =
                      this.userList[i].commissionQuota + "%";
                  }
                }
              }
            } else {
              this.userList = [];
            }
          } else {
            this.showFlag = false;
            this.$message.error(response.data.message);
          }
          this.dialogUserListShow = true;
          this.loading = false;
          if (userId) {
            loading.close();
          }
        })
        .catch(err => {
          this.loading = false;
          if (userId) {
            loading.close();
          }
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 编辑
    editDiscount(row) {
      this.specialUserForm.couponCurrency = "CNY";
      this.specialUserForm.commissionCurrency = "CNY";
      this.specialUserForm.couponCategory = row.couponCategory;
      this.specialUserForm.field = row.field;
      this.specialUserForm.category = row.category;
      this.specialUserForm.courseNumber = row.courseNumber;
      this.specialUserForm.courseName = row.courseName;
      this.specialUserForm.courseNumber6s = row.courseNumber6s;
      // 学生优惠
      if (row.couponType != 1) {
        // 金额
        this.specialUserForm.couponType = "0";
        if (row.couponQuota != null && row.couponQuota != "") {
          // 货币格式
          if (row.couponQuota == 0) {
            this.specialUserForm.studentNumber = "0.00";
          } else {
            if (row.couponQuota.toString().includes(".")) {
              this.specialUserForm.studentNumber =
                row.couponQuota.toString().split(".")[1].length < 2
                  ? row.couponQuota.toString().split(".")[1].length < 1
                    ? row.couponQuota.toString() + "00"
                    : row.couponQuota.toString() + "0"
                  : row.couponQuota;
            } else {
              this.specialUserForm.studentNumber =
                row.couponQuota.toString() + ".00";
            }
          }
        } else if (row.couponQuota == 0) {
          this.specialUserForm.studentNumber = "0.00";
        } else {
          this.specialUserForm.studentNumber = row.couponQuota;
        }
        this.specialUserForm.studentRate = "";
      } else {
        // %
        this.specialUserForm.couponType = row.couponType;
        this.specialUserForm.studentRate = row.couponQuota;
        this.specialUserForm.studentNumber = "";
      }
      // 佣金
      if (row.commissionType != 1) {
        // 金额
        this.specialUserForm.commissionType = "0";
        if (row.commissionQuota != null && row.commissionQuota != "") {
          // 货币格式
          if (row.commissionQuota == 0) {
            this.specialUserForm.introducerNumber = "0.00";
          } else {
            if (row.commissionQuota.toString().includes(".")) {
              this.specialUserForm.introducerNumber =
                row.commissionQuota.toString().split(".")[1].length < 2
                  ? row.commissionQuota.toString().split(".")[1].length < 1
                    ? row.commissionQuota.toString() + "00"
                    : row.commissionQuota.toString() + "0"
                  : row.commissionQuota;
            } else {
              this.specialUserForm.introducerNumber =
                row.commissionQuota.toString() + ".00";
            }
          }
        } else if (row.commissionQuota == 0) {
          this.specialUserForm.introducerNumber = "0.00";
        } else {
          this.specialUserForm.introducerNumber = row.commissionQuota;
        }
        this.specialUserForm.introducerRate = "";
      } else {
        // %
        this.specialUserForm.commissionType = row.commissionType;
        this.specialUserForm.introducerRate = row.commissionQuota;
        this.specialUserForm.introducerNumber = "";
      }
      this.oldSpecialUserForm = JSON.stringify(this.specialUserForm);
      this.studentNumberOld = this.specialUserForm.studentNumber;
      this.studentRateOld = this.specialUserForm.studentRate;
      this.introducerNumberOld = this.specialUserForm.introducerNumber;
      this.introducerRateOld = this.specialUserForm.introducerRate;
      this.dialogFormVisible = true;
    },
    // 重置
    reset() {
      // this.specialDouponForm = {};
      // this.userList=[]
      this.specialDouponForm.queryUser = "";
      this.$refs.specialDouponFormRef.resetFields();
      this.showFlag = false;
    },
    // 比较数据是否发生变更
    specialUserFormChanged() {
      if (this.oldSpecialUserForm === JSON.stringify(this.specialUserForm)) {
        this.$message({
          message: this.$t("common.contentIsUnchanged"),
          type: "warning"
        });
        return true;
      }
      return false;
    },
    // 提交
    handleSubmit() {
      this.$refs["specialUserFormRef"].validate(async valid => {
        if (valid) {
          if (this.specialUserFormChanged()) {
            return;
          }
          // const loading = this.$loading({
          //   lock: true,
          //   text: this.$t("common.loading"),
          //   background: "rgba(255,255,255,0.8)",
          //   target: document.querySelector("#main-container")
          // });
          this.specialUserForm.couponCode = this.specialDouponForm.couponCode;
          console.log("this.specialUserForm", this.specialUserForm);
          let url = "/api/couponCode/submitSpecialCoupon";
          this.$http
            .post(url, this.specialUserForm)
            .then(response => {
              if (response.data.code === 200) {
                // this.$message.success(response.data.message);
                this.getSpecialCouponCode();
                this.$message.success(this.$t("p0413.specialSetSuccess"));
              } else {
                this.$message.error(response.data.message);
              }
              // loading.close();
            })
            .catch(err => {
              // loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
          await this.getSpecialCouponCode();
          await this.handleClose();
        }
      });
    },
    // 改变优惠方式
    changeStuNo() {
      this.specialUserForm.studentRate = "";
      this.specialUserForm.studentNumber = this.studentNumberOld;
      this.$refs.specialUserFormRef.clearValidate("studentRate");
    },
    changeStuRate() {
      this.specialUserForm.studentNumber = "";
      this.specialUserForm.studentRate = this.studentRateOld;
      this.$refs.specialUserFormRef.clearValidate("studentNumber");
    },
    changeIntNo() {
      this.specialUserForm.introducerRate = "";
      this.specialUserForm.introducerNumber = this.introducerNumberOld;
      this.$refs.specialUserFormRef.clearValidate("introducerRate");
    },
    changeIntRate() {
      this.specialUserForm.introducerNumber = "";
      this.specialUserForm.introducerRate = this.introducerRateOld;
      this.$refs.specialUserFormRef.clearValidate("introducerNumber");
    },
    formatStuNumber() {
      this.$refs["specialUserFormRef"].validateField("studentNumber", valid => {
        if (!valid) {
          if (
            this.specialUserForm.studentNumber != null &&
            this.specialUserForm.studentNumber != ""
          ) {
            // 货币格式
            if (this.specialUserForm.studentNumber == 0) {
              this.specialUserForm.studentNumber = "0.00";
            } else {
              if (this.specialUserForm.studentNumber.toString().includes(".")) {
                this.specialUserForm.studentNumber =
                  this.specialUserForm.studentNumber.toString().split(".")[1]
                    .length < 2
                    ? this.specialUserForm.studentNumber
                        .toString()
                        .split(".")[1].length < 1
                      ? this.specialUserForm.studentNumber.toString() + "00"
                      : this.specialUserForm.studentNumber.toString() + "0"
                    : this.specialUserForm.studentNumber;
              } else {
                this.specialUserForm.studentNumber =
                  this.specialUserForm.studentNumber.toString() + ".00";
              }
            }
          }
        }
      });
    },
    formatIntNumber() {
      this.$refs["specialUserFormRef"].validateField(
        "introducerNumber",
        valid => {
          if (!valid) {
            if (
              this.specialUserForm.introducerNumber != null &&
              this.specialUserForm.introducerNumber != ""
            ) {
              // 货币格式
              if (this.specialUserForm.introducerNumber == 0) {
                this.specialUserForm.introducerNumber = "0.00";
              } else {
                if (
                  this.specialUserForm.introducerNumber.toString().includes(".")
                ) {
                  this.specialUserForm.introducerNumber =
                    this.specialUserForm.introducerNumber
                      .toString()
                      .split(".")[1].length < 2
                      ? this.specialUserForm.introducerNumber
                          .toString()
                          .split(".")[1].length < 1
                        ? this.specialUserForm.introducerNumber.toString() +
                          "00"
                        : this.specialUserForm.introducerNumber.toString() + "0"
                      : this.specialUserForm.introducerNumber;
                } else {
                  this.specialUserForm.introducerNumber =
                    this.specialUserForm.introducerNumber.toString() + ".00";
                }
              }
            }
          }
        }
      );
    },
    // 关闭弹窗，清除数据
    handleClose() {
      this.dialogFormVisible = false;
      // this.$refs.specialUserFormRef.resetFields();
      // this.specialUserForm.studentNumber = "";
      // this.specialUserForm.studentRate = "";
      // this.specialUserForm.introducerNumber = "";
      // this.specialUserForm.introducerRate = "";
    },
    // 关闭弹窗，清除数据
    handleUserListClose() {
      this.dialogUserListShow = false;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
>>> .el-button--submit {
  width: 80px;
  height: 32px;
  margin-top: 4px;
}
>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
>>> .el-tabs__item {
  font-size: 15px;
}
>>> .el-radio {
  display: block;
  line-height: 40px;
  white-space: normal;
  margin-right: 0;
}
.spanWidth {
  min-width: 150px;
  display: inline-block;
}
.spanWidth1 {
  min-width: 50px;
  display: inline-block;
}
>>> .el-input--small .el-input__inner {
  text-align: right;
}
>>> .el-dialog__body {
  padding: 0 10px;
}
>>> .el-divider--horizontal {
  margin: 14px 0;
}
/* 提交 */
.el-button--submitDialog {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  width: 61px;
  height: 26px;
  white-space: pre-wrap;
  padding: 0;
  font-family: "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 18px;
}
>>> .el-form-item {
  margin-bottom: 0px;
}
.userListClass {
  //弹窗样式
  >>> .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(90vh - 140px);
  }
  >>> .el-dialog__body {
    height: 700px;
  }
  @media screen and (max-width: 1600px) {
    >>> .el-dialog__body {
      height: 440px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0415.vue